module.exports = __webpack_public_path__ + "img/el-ic-express.49550cfd.svg";